// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p1-1";
export var messageSideRight = "_p1-2";
export var subscribeToBackInStockBubbleContainer = "_p1-0";